import React from 'react';
import "./CSS/PrivacyPolicy.css"

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <h1>Privacy Policy</h1>
      
      <h2>1. Introduction</h2>
      <p>
        Panache By Funmi ("we," "us," "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website <a href="https://panachebyfunmi.com">panachebyfunmi.com</a> (the "Site") and purchase our products. By using our Site, you consent to the collection and use of your information in accordance with this Privacy Policy.
      </p>

      <h2>2. Information We Collect</h2>
      <h3>2.1 Personal Information</h3>
      <p>
        We collect personal information that you provide to us, including but not limited to, your name, address, phone number, and payment information.
      </p>
      <h3>2.2 Automatically Collected Information</h3>
      <p>
        We automatically collect certain information when you visit our Site, such as your IP address, browser type, operating system, and browsing behavior.
      </p>
      <h3>2.3 Cookies</h3>
      <p>
        We use cookies and similar tracking technologies to enhance your experience on our Site. You can control cookie settings through your browser.
      </p>

      <h2>3. How We Use Your Information</h2>
      <p>We use the information we collect to:</p>
      <ul>
        <li>Process and fulfill your orders;</li>
        <li>Verify your identity;</li>
        <li>Communicate with you regarding your orders and promotions;</li>
        <li>Improve our Site and services;</li>
        <li>Comply with legal obligations.</li>
      </ul>

      <h2>4. How We Share Your Information</h2>
      <p>We may share your information with:</p>
      <h3>4.1 Service Providers</h3>
      <p>
        We use Paystack to process payments and may share your information with them for this purpose.
      </p>
      <h3>4.2 Legal Compliance</h3>
      <p>
        We may disclose your information to comply with legal obligations or to protect our rights.
      </p>
      <h3>4.3 Business Transfers</h3>
      <p>
        In the event of a merger, sale, or acquisition, your information may be transferred to the new business entity.
      </p>

      <h2>5. Security</h2>
      <p>
        We implement appropriate technical and organizational measures to safeguard your information from unauthorized access, use, or disclosure. However, no method of transmission over the internet or electronic storage is completely secure.
      </p>

      <h2>6. Your Rights</h2>
      <p>Depending on your jurisdiction, you may have the following rights regarding your personal information:</p>
      <ul>
        <li>Access your personal data;</li>
        <li>Correct or update inaccurate information;</li>
        <li>Request deletion of your data;</li>
        <li>Object to the processing of your data;</li>
        <li>Withdraw consent (if applicable).</li>
      </ul>

      <h2>7. Third-Party Links</h2>
      <p>
        Our Site may contain links to third-party websites. We are not responsible for the privacy practices or content of those sites. We encourage you to review their privacy policies.
      </p>

      <h2>8. Children's Privacy</h2>
      <p>
        Our Site is not intended for individuals under the age of 13. We do not knowingly collect personal information from children.
      </p>

      <h2>9. Changes to This Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Any changes will be posted on this page, and we will update the "Last Updated" date at the top of this page.
      </p>

      <h2>10. Contact Us</h2>
      <p>
        If you have any questions or concerns about this Privacy Policy, please contact us at <a href="mailto:info@panachebyfunmi.com" className='terms'>info@panachebyfunmi.com</a>.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
